module.exports = __webpack_public_path__ + "img/minus_btn.d9b18625.png";